import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26e2e9b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Update ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    title: _ctx.name,
    style: {"text-align":"left"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        layout: "vertical",
        ref: "formRef",
        model: _ctx.form,
        onFinish: _ctx.handleFinish,
        id: "myForm"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_row, { gutter: [24, 2] }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                sm: { span: 24 },
                md: { span: 12 },
                lg: { span: 12 },
                style: {"margin-bottom":"50px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_card, { bordered: true }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, {
                        label: "Name",
                        name: "name"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            type: "text",
                            id: "name",
                            value: _ctx.form.vendor_name,
                            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.vendor_name) = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, {
                        label: "Vendor ID",
                        name: "vendor_id"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            type: "text",
                            id: "vendor_id",
                            value: _ctx.form.vendor_id,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.vendor_id) = $event)),
                            disabled: true
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, {
                        label: "Email",
                        name: "email"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            type: "text",
                            id: "email",
                            value: _ctx.form.email,
                            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.email) = $event)),
                            disabled: true
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, {
                        label: "Contact No:",
                        name: "contact_no"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            type: "text",
                            id: "contact_no",
                            value: _ctx.form.contact_no,
                            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.contact_no) = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, {
                        label: "Address:",
                        name: "address"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            type: "text",
                            id: "address",
                            value: _ctx.form.address,
                            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.address) = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, {
                sm: { span: 24 },
                md: { span: 12 },
                lg: { span: 12 }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_card, {
                    bordered: true,
                    style: {"margin-bottom":"20px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, {
                        label: "Current Password",
                        name: "current_password"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            type: "password",
                            id: "current_password",
                            value: _ctx.form.current_password,
                            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.current_password) = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, {
                        label: "New Password",
                        name: "password"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            type: "password",
                            id: "password",
                            value: _ctx.form.password,
                            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.password) = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, {
                        label: "Confirm Password",
                        name: "password_confirmation"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            type: "password",
                            id: "password_confirmation",
                            value: _ctx.form.password_confirmation,
                            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.password_confirmation) = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { style: {"text-align":"right","margin-bottom":"0"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        key: "submit",
                        htmlType: "submit",
                        loading: _ctx.loading
                      }, {
                        default: _withCtx(() => [
                          _hoisted_1
                        ]),
                        _: 1
                      }, 8, ["loading"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "onFinish"])
    ]),
    _: 1
  }, 8, ["title"]))
}